import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    ViewContainerRef,
    ElementRef
  } from '@angular/core';
  
  // Servicios
  import { DragulaService } from 'ng2-dragula';
  // Components
  import { SxBaseContainerDesigner } from '../../base/base-container-designer-component';
  import {
    DesignAttributeType,
    OptionsAttribute,
    AttributeChangeEventArgsType
  } from '../../../../types/designer-attribute-type';
  import { IDesignerFactoryService } from '../../../../services/designer-factory-interface';
  import { NgxSmartModalService } from 'ngx-smart-modal';
  
  @Component({
    selector: 'sx-group-collapsible-designer',
    templateUrl: './group-collapsible.designer.component.html'
  })
  export class SxGroupCollapsibleDesigner extends SxBaseContainerDesigner
    implements OnInit, OnDestroy {
    @ViewChild('groupCollapsiblePanelContainer', { read: ViewContainerRef })
    private groupCollapsiblePanelContainer: ViewContainerRef;
  
    constructor(
      dragulaService: DragulaService,
      designerFactoryService: IDesignerFactoryService,
      container: ElementRef,
      public ngxSmartModalService: NgxSmartModalService
    ) {
      super(dragulaService, designerFactoryService, 'SxGroupCollapsible', container);
    }
  
    loadDefaults(): void {
      super.loadDefaults();
      this.controlContext.titleSize = 'medium';
    }
  
    getElementModal(instance: any) {
      this.ngxSmartModalService.setModalData(instance, 'attributesModal');
      this.ngxSmartModalService.getModal('attributesModal').open();
    }
  
    getDesignerInfo(): any {
      const info = super.getDesignerInfo();
  
      info['title'] = this.controlContext.title;
      info['titleSize'] = this.controlContext.titleSize;
      info['asyncDisplayDependency'] = this.controlContext.asyncDisplayDependency;
  
      return info;
    }
  
    buildAttributes(): void {
      super.buildAttributes();
  
      const titleAtt = new DesignAttributeType(
        this.controlContext,
        'string',
        'title'
      );
      const sizes = [
        { id: 'small', name: 'Small' },
        { id: 'medium', name: 'Medium' },
        { id: 'large', name: 'Large' }
      ];
      const sizeAtt = new OptionsAttribute(this.controlContext, sizes, 'titleSize', 'Size');
      sizeAtt.change.subscribe(v => this.onSizeAttChange(v));
      const asyncDependenciesAtt = new DesignAttributeType(
        this.controlContext,
        'string',
        'asyncDisplayDependency',
        'Async display dependency'
      );
  
      this.attributes.push(
        titleAtt,
        sizeAtt,
        asyncDependenciesAtt
        );
    }

    onSizeAttChange(args: AttributeChangeEventArgsType): void {
      this.controlContext.titleSize = args.newValue;
    }
  
    ngOnInit(): void {
      this.placeHolderContainer = this.groupCollapsiblePanelContainer;
      super.ngOnInit();
    }
  
    ngOnDestroy(): void {
      super.ngOnDestroy();
    }
  }
  


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/containers/group-collapsible.designer.component.ts